import { defaultFont } from 'src/theme/core/typography';

// ----------------------------------------------------------------------

export const STORAGE_KEY = 'app-settings';

export const fontOptions = [defaultFont, 'Estedad Variable', 'Shabnam', 'Nunito Sans'];

export const defaultSettings = {
  colorScheme: 'light',
  direction: 'rtl',
  contrast: 'default',
  navLayout: 'vertical',
  primaryColor: 'default',
  navColor: 'integrate',
  compactLayout: true,
  fontFamily: defaultFont,
};
